import { Component, TemplateRef, ViewChild } from "@angular/core";
import { NbMenuService } from "@nebular/theme";
import { AuthService } from "./services/authFirebase/auth.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AngularFirestore, } from "@angular/fire/firestore";
import { AngularFireAuth } from "@angular/fire/auth";
import { CompanyFocusService } from "./services/companyOnFocus/company-focus.service";
import { Subscription, interval } from "rxjs";
import { InComingCallService } from "./services/inComingCall/in-coming-call.service";
import { CompanyService } from "./services/company/company.service";
import { ContactService } from "./services/contact/contact.service";
import { formatDate } from "@angular/common";
import { CallsReportsService } from '../app/services/calls-reports/calls-reports.service'
import { first } from 'rxjs/operators';
import { DateTime } from 'luxon';
import Swal from "sweetalert2";
import { UserService } from "./services/users/user.service";
import { UserData } from "./models/user";
import { environment } from "src/environments/environment";
import { ProspectsService } from "./services/prospects/prospects.service";
import {io} from 'socket.io-client';
import { ReporteService } from "./services/reportes/reporte.service";
import * as firebase from "firebase";
import 'firebase/messaging';
import { log } from "console";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {

  adminMenu = [
    { title: "Mi perfil", icon: "person", data: { id: "profile" } },
    { title: "Pendientes", icon: "notifications", data: { id: "pendings" } },
    { title: "Agenda", icon: "calendar_today", data: { id: "user-schedule" } },
    //{ title: "Registro de pagos", icon: "attach_money", data: { id: "payments" } },
  ];
  menuMovilAdmin = [
    { title: "Dashboard", data: { id: "dashboard" } },
    { title: "Clientes", data: { id: "clientes" } },
    { title: 'Ejecutivos', data: { id: 'ejecutivos' } },
    { title: 'Reportes', data: { id: 'reportes' } },
    { title: 'Reportes rentabilidad', data: { id: 'reportes' } },
    { title: 'Reportes de agentes', data: { id: 'reportes' } },
    { title: 'Reportes Semanales', data: { id: 'reportesSemanales' } },
    {title: 'Reportes de Excedentes', data: {id: 'reportesExcedentes'}},
    {title: 'Reporte de actividades', data: {id: 'reporteActividades'}},
  ];
  menuMovil = [
    { title: "Dashboard", data: { id: "dashboard" } },
    { title: "Clientes", data: { id: "clientes" } },
    { title: 'Llamadas', data: { id: 'llamadas' } },
  ];
  flag: String;
  idCall: any;
  imgUrl: any;
  nombreCompany: any;
  idCompany: any;
  currentCaller: any = {};
  data: any;
  callBackSubscription: Subscription;
  public wpClose: boolean = true;
  public missingCalls = []
  public newMissingCall = false
  public loader = false;
  public hasNewWeeklyReport: boolean = false;
  public modalCall = false;
  public closeModalCall = false;
  public modalICCalls: TemplateRef<any>;
  public callerCompany: any;
  public currentCustomerCaller: any;
  public currrentIncomingCall = [];
  public session: boolean;
  public clientLoader: boolean;
  public callerIdentified: boolean;
  public user!: UserData;
  public callSubscription: Subscription;
  public defaultImg = "https://firebasestorage.googleapis.com/v0/b/miasistema.appspot.com/o/profileDefault.png?alt=media&token=11dfec0b-5b69-448d-801b-6adefa90690f"
  public devVersion = 'v' + environment.version
  private socket: ReturnType<typeof io>;

  constructor(
    private menuService: NbMenuService,
    private service: AuthService,
    public router: Router,
    private afs: AngularFirestore,
    private focusCompanyService: CompanyFocusService,
    private iCCService: InComingCallService,
    private companyService: CompanyService,
    private contactService: ContactService,
    private afAuth: AngularFireAuth,
    private callsService: CallsReportsService,
    private userService: UserService,
    private prospectService: ProspectsService,
    private reporteService: ReporteService,
  ) {
    this.menuService.onItemClick().subscribe(async (event) => {
      switch (event.item.title) {
        case "Dashboard":
          this.router.navigate(["dashboard"]);
          break;
        case "Clientes":
          this.router.navigate(["clients"]);
          break;
        case "Ejecutivos":
          this.router.navigate(["users"]);
          break;
        case "Reportes":
          this.router.navigate(["reportes"]);
          break;
        case "Reportes rentabilidad":
          this.router.navigate(["reporte-rentabilidad"]);
          break;
        case "Reportes de agentes":
          this.router.navigate(["reporte-agentes"]);
          break;
        case "Llamadas":
          this.router.navigate(["reportes-llamadas"]);
          break;
        case "Pendientes":
          this.router.navigate(["pendings"]);
          break;
        case "Agenda":
          this.router.navigate(["user-schedule"]);
          break;
        case "Panel Ventas":
          this.router.navigate(["marketing"]);
          break;
      }
    });

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.afAuth.authState.subscribe(async (session) => {
      if (!session) return;

      // 1️⃣ Solicitar permisos de notificación
      if ("Notification" in window && Notification.permission !== "granted") {
        await Notification.requestPermission();
      }

      // 2️⃣ Obtener usuario actual
      let currentUserId = this.service.currentuser().uid;
      this.user = await this.userService.getUserById(currentUserId);

      try {
        this.hasNewWeeklyReport = await this.reporteService.hasUnreadWeeklyReports();
      } catch (error) {
        console.error("Error checking weekly reports:", error);
      }

      // 3️⃣ Registrar Service Worker
      let registration: ServiceWorkerRegistration | null = null;
      if ('serviceWorker' in navigator) {
        try {
          registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
          //console.log('Service Worker registrado:', registration);
        } catch (err) {
          console.error('Error registrando Service Worker:', err);
        }
      }

      // 4️⃣ Inicializar Firebase Messaging
      const messaging = firebase.messaging();

      // Configurar la VAPID key una sola vez inmediatamente después de instanciar
      try {
        messaging.usePublicVapidKey('BMfS9n9btRXoFcaz88yuHDfd2R0jlIKk1Kosclh19kRC93FwjiHsSD5pkJ9PXr9Wrw1Jr3NANEBtyoUvO0gTAKc');
      } catch (e) {
        // Captura en caso de que ya se haya asignado previamente en el ciclo de vida
      }

      // 5️⃣ Obtener token FCM y guardar en backend
      try {
        if (Notification.permission === "granted") {
          // Se llama a getToken() directamente sin volver a invocar usePublicVapidKey()
          const token = await messaging.getToken();

          console.log("🔥 FCM Token obtenido en Front:", token);

          if (token) {
            await this.userService.saveUserToken(this.user.uid, token);
            console.log("✅ Token guardado en BD para:", this.user.uid);
          } else {
            console.warn("⚠️ messaging.getToken() devolvió null");
          }
        } else {
          console.warn("⚠️ Permiso de notificaciones no concedido:", Notification.permission);
        }
      } catch (error) {
        console.error("❌ Error al obtener token FCM:", error);
      }

      // 6️⃣ Escuchar mensajes en foreground
      messaging.onMessage((payload) => {
        console.log('Mensaje recibido en foreground:', payload);

        // Mostrar SweetAlert
        Swal.fire({
          icon: "info",
          title: payload.notification?.title || "📌 Nuevo pendiente",
          html: `<div style="text-align:left;">${payload.notification?.body || ""}</div>`,
          confirmButtonText: "Entendido",
          confirmButtonColor: "#3085d6",
          background: "#f9f9f9"
        });

        // Mostrar notificación push real en foreground
        /* if (Notification.permission === "granted" && registration) {
          registration.showNotification(
            payload.notification?.title || "📌 Nuevo pendiente",
            {
              body: payload.notification?.body || "",
              icon: payload.notification?.icon || "https://firebasestorage.googleapis.com/v0/b/miasistema.appspot.com/o/logo_circle.png?alt=media",
              data: payload.data || {}
            }
          );
        } */
      });

      // 7️⃣ --- SOCKET.IO ---
      if (!this.socket) {
        this.socket = io('https://miasistente.herokuapp.com', {
          reconnection: true,
          reconnectionAttempts: Infinity,
          reconnectionDelay: 1000,
          timeout: 5000,
        });
      }

      if (!this.user?.uid) return;

      this.socket.emit("registerUser", this.user.uid);

      // Listener de nuevos pendientes
      this.socket.off("newPending");
      this.socket.on("newPending", (pending: any) => {
        //if (pending.userId === this.user.uid) return;

        // Disparar Alarma Sonora + Ventana Emergente
        this.triggerEmergencyAlert({
          title: pending.title,
          comments: pending.comments,
          clientName: pending.clientName
        });

        // SweetAlert
        Swal.fire({
          icon: "info",
          title: "📌 Nuevo recordatorio",
          html: `
            <div style="text-align:left;">
              <p><strong>Título:</strong> ${pending.title}</p>
              <p><strong>Comentarios:</strong> ${pending.comments || "Sin comentarios"}</p>
            </div>
          `,
          confirmButtonText: "Entendido",
          confirmButtonColor: "#3085d6",
          background: "#f9f9f9"
        });

        // Notificación push
        /* if (Notification.permission === "granted" && registration) {
          registration.showNotification("📌 Nuevo pendiente", {
            body: `📝 ${pending.title}\n💬 ${pending.comments || "Sin comentarios"}`,
            icon: "https://firebasestorage.googleapis.com/v0/b/miasistema.appspot.com/o/logo_circle.png?alt=media"
          });
        } */
      });

      // Listener de recordatorios próximos o vencidos
      this.socket.off("reminderAlert");
      this.socket.on("reminderAlert", (data: any) => {

        // Disparar Alarma Sonora + Ventana Emergente
        this.triggerEmergencyAlert({
          title: data.title,
          comments: data.comments,
          clientName: data.clientName
        });

        Swal.fire({
          icon: data.type === "aboutToExpire" ? "warning" : "error",
          title: data.type === "aboutToExpire" ? "⏰ Recordatorio próximo a vencer" : "⚠️ Recordatorio vencido",
          html: `
            <div style="text-align:left;">
              <p><strong>Tarea:</strong> ${data.title}</p>
              ${data.clientName ? `<p><strong>Cliente:</strong> ${data.clientName}</p>` : ''}
              <p><strong>Detalles:</strong> ${data.comments || "Sin comentarios"}</p>
            </div>
          `,
          confirmButtonText: "Entendido",
          confirmButtonColor: data.type === "aboutToExpire" ? "#e67e22" : "#c0392b",
          background: "#f9f9f9"
        });
        
        /* if (Notification.permission === "granted" && registration) {
          registration.showNotification(
            data.type === "overdue" ? "⚠️ Pendiente vencido" : "⏳ Pendiente por vencer",
            {
              body: `📝 ${data.title}\n👤 Cliente: ${data.clientName || 'N/A'}\n💬 ${data.comments || "Sin comentarios"}`,
              icon: "https://firebasestorage.googleapis.com/v0/b/miasistema.appspot.com/o/logo_circle.png?alt=media"
            }
          );
        } */
        
        //this.openReminderPopup(data);
      });

      // Conectar y registrar listeners
      this.socket.on('connect', () => console.log("Socket.io - Conectado"));
      this.socket.on("disconnect", () => console.log("Socket.io - Desconectado. Reintentando conexión..."));
      if (this.socket.connected) console.log("Socket.io ya conectado");

      this.socket.off("newWeeklyReport");
      this.socket.on("newWeeklyReport", async () => {
        console.log("Nuevo reporte semanal detectado");

        this.hasNewWeeklyReport = true;

        // Opcional: notificación visual
        Swal.fire({
          icon: "info",
          title: "📊 Nuevo reporte semanal",
          text: "Se ha generado un nuevo reporte semanal",
          confirmButtonText: "Ver",
          confirmButtonColor: "#3085d6"
        });
      });

      // 8️⃣ Incoming Calls & estado de sesión
      this.incomingCallsListener();
      this.session = true;
      localStorage.setItem("currentUser", this.user.tipo);
      this.clientLoader = true;
});


    var response = this.callsService.observerMissingCalls()
    response.subscribe(result => {
      if (result) {
        this.newMissingCall = true;
      }
    })
    setTimeout(() => {
      this.newMissingCall = false;
    }, 2000);
  }

  ngOnInit() {
  }

  async logOut() {
    await this.service.logoutUser();
    location.reload();
  }

  toggle() {
    this.wpClose = !this.wpClose;
    if (!this.wpClose) {
      try {
        this.loader = true
        this.newMissingCall = false;
        this.missingCalls = []
        this.afAuth.authState.subscribe(async (session) => {
          if (session) {
            let currentUserId = this.service.currentuser().uid;
            var userInfo = await this.userService.getUserById(currentUserId)
            if (userInfo.tipo == "administrador") {
              var clientsPhone = []
              var allCalls = await this.callsService.getMissingCall()
              for await (const call of allCalls) {
                if (!clientsPhone.includes(call.did)) {
                  clientsPhone.push(call.did)
                }
              }
              for await (const client of clientsPhone) {
                var clientInfo = await this.companyService.getCompanyByPhoneNumber(parseInt(client))
                if (clientInfo != undefined) {
                  var calls = await this.callsService.getMissingCallsByPhoneClient(clientInfo.telefono)
                  if (calls.length != 0) {
                    this.missingCalls.push({ client: clientInfo.nombre, calls: calls.length })
                  }
                }
              }
              this.loader = false;
            }
            else {
              var allClients = await this.companyService.getCompaniesByUserName(userInfo.nombre)
              for await (const client of allClients) {
                var calls = await this.callsService.getMissingCallsByPhoneClient(client.telefono)
                console.log(calls);
                if (calls.length != 0) {
                  this.missingCalls.push({ client: client.nombre, calls: calls.length })
                }
              }
              this.loader = false;
            }
          }
        })
      } catch (error) {
        Swal.fire({
          title: 'Ocurrió un error',
          text: "Si el problema persiste, favor de reportar el error"
        })
      }
    }
  }

  async openReminderPopup(data: any) {
    try {
      
      localStorage.setItem("currentReminderPopup", JSON.stringify(data));

      const width = 450;
      const height = 400;
      const left = (screen.width / 2) - (width / 2);
      const top = (screen.height / 2) - (height / 2);

      window.open(
        "/reminder-popup", 
        "_blank", 
        `width=${width},height=${height},top=${top},left=${left},resizable=no,scrollbars=no,status=no`
      );
    } catch (error) {
      console.error("Error al abrir la ventana emergente de recordatorio:", error);
    }
  }

  triggerEmergencyAlert(data: { title: string; comments?: string; clientName?: string }) {

    console.log("🔔 Triggering emergency alert for pending task:", data);
    const width = 500;
    const height = 420;
    const left = Math.round((screen.width - width) / 2);
    const top = Math.round((screen.height - height) / 2);

    // Intentar abrir la ventana emergente
    const popupWindow = window.open(
      'about:blank',
      'AlarmaPendiente_' + Date.now(),
      `width=${width},height=${height},top=${top},left=${left},resizable=no,scrollbars=no,status=no,toolbar=no`
    );

    // Si popupWindow es null o undefined, Chrome bloqueó la ventana
    if (!popupWindow || popupWindow.closed || typeof popupWindow.closed === 'undefined') {
      console.error("❌ La ventana emergente fue BLOQUEADA por el navegador. Habilita los pop-ups en la barra de navegación.");
      alert("⚠️ Tu navegador bloqueó la ventana emergente de la alarma. Por favor permite los Pop-ups para este sitio.");
      return;
    }

    // Reproducir sonido
    const alarmAudio = new Audio('https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3');
    alarmAudio.loop = true;
    alarmAudio.play().catch(err => console.warn("Audio bloqueado:", err));

    (window as any).stopGlobalAlarm = () => {
      alarmAudio.pause();
      alarmAudio.currentTime = 0;
    };

    // Inyectar HTML
    const popupContent = `
      <!DOCTYPE html>
      <html lang="es">
      <head>
        <meta charset="UTF-8">
        <title>🚨 ALARMA DE PENDIENTE</title>
        <style>
          body { background-color: #d9534f; color: white; font-family: Arial, sans-serif; text-align: center; padding: 20px; margin: 0; }
          h1 { font-size: 24px; margin-bottom: 15px; }
          .card { background: rgba(255, 255, 255, 0.2); border-radius: 8px; padding: 15px; text-align: left; font-size: 15px; }
          .btn { background-color: #ffffff; color: #d9534f; font-weight: bold; border: none; padding: 14px 28px; font-size: 16px; border-radius: 6px; cursor: pointer; margin-top: 20px; width: 100%; }
        </style>
      </head>
      <body>
        <h1>⏰ ¡TIENES UN PENDIENTE!</h1>
        <div class="card">
          <p><strong>Tarea:</strong> ${data.title || "Sin título"}</p>
          ${data.clientName ? `<p><strong>Cliente:</strong> ${data.clientName}</p>` : ''}
          <p><strong>Detalles:</strong> ${data.comments || "Sin comentarios"}</p>
        </div>
        <button class="btn" onclick="stopAlarm()">ENTENDIDO / APAGAR ALARMA</button>
        <script>
          function stopAlarm() {
            if (window.opener && !window.opener.closed && window.opener.stopGlobalAlarm) {
              window.opener.stopGlobalAlarm();
            }
            window.close();
          }
        </script>
      </body>
      </html>
    `;

    popupWindow.document.open();
    popupWindow.document.write(popupContent);
    popupWindow.document.close();
    popupWindow.focus();
  }

  async takePhoneCall(data) {
    let iCC = data;
    let ref = this.afs.collection("incomingCalls").doc(data.id);
    this.focusCompanyService.setFocusCall();
    this.focusCompanyService.setContact(data);
    var companyDoc = await this.companyService.getCompanyByPhoneNumber(iCC.numero_destino);
    if (companyDoc == null) return;

    this.focusCompanyService.setFocusCompany(companyDoc.id);
    var companyContact = await this.contactService.getContact(iCC.numero_origen, companyDoc.id);
    if (companyContact == null) {
      this.modalCall = false;
      await this.contactService.addContact(iCC, companyDoc.id);
      await ref.delete();
      this.iCCService.removeIncomingCall(iCC.id);
      localStorage.setItem("initTimeCall", DateTime.fromISO(new Date().toDateString()).toString())
      this.router.navigate(["diary"], companyDoc);
      return;
    }
    this.modalCall = false;
    await ref.delete();
    if (this.router.url == "/incomming-call") {
      window.close()
    }
    this.iCCService.removeIncomingCall(iCC.id);
    this.closeModal();
    localStorage.setItem("initTimeCall", new Date().toString())
    this.router.navigate(["diary"], companyDoc);
  }

  closeModal() {
    this.closeModalCall = !this.closeModalCall
  }
  
  async checkWeeklyReports() {
    try {
      this.hasNewWeeklyReport = await this.reporteService.hasUnreadWeeklyReports();
    } catch (error) {
      console.error("Error checking weekly reports:", error);
    }
  }

  async cancelCall(currentCall) {
    try {
      this.modalCall = false;
      this.closeModalCall = false;
      await this.iCCService.removeIncomingCall(currentCall.id);
      localStorage.setItem("isCallOnFocus", "false")
      this.callBackSubscription.unsubscribe();
      await this.iCCService.lostICC(currentCall, this.callerCompany);
      if (this.router.url == "/incomming-call") {
        window.close()
      }
      // var companyDoc = await this.companyService.getCompanyByPhoneNumber(currentCall.numero_destino);
      // if (companyDoc == null) return;
      // const indexCall = this.currrentIncomingCall.findIndex(call => call.id == currentCall.id)
      // if (indexCall != -1) {
      //   this.currrentIncomingCall.splice(indexCall, 1);
      // }
      // if (companyDoc == null) return;
    } catch (error) {
      console.log("error... cancelling callback subscription")
    }

  }

  async incomingCallsListener() {
    try {
      var session = await this.afAuth.authState.pipe(first()).toPromise();
      if (session == null) return;

      var inComingCall$ = this.iCCService.getInComingCalls(this.user.extension ?? 3001);
      this.callSubscription = inComingCall$.subscribe(async calls => {
        if (calls.length == 0) return;
        var individualCall = calls[0];
        var endTime = new Date();
        var difference = endTime.getTime() - individualCall.date.seconds * 1000; // This will give difference in milliseconds
        var resultInMinutes = Math.round(difference / 60000);
        if (resultInMinutes > 5) {
          try {
            this.modalCall = false;
            this.closeModalCall = false;
          } catch (error) { }
          return;
        }
        this.currrentIncomingCall = [];

        this.idCall = individualCall.id;
        var callerPhoneNumber = individualCall.numero_origen;
        const companyPhoneNumber = individualCall.numero_destino;
        localStorage.setItem("iCCId", individualCall.id);
        var companyDoc = await this.prospectService.getProspectByPhone(companyPhoneNumber);
        if (companyDoc == null) {
          //Se busca el numero en los numeros adicionales del cliente en caso de no ser el principal
          var secondDoc = await this.companyService.findCompanyWhitDifferentNumber(companyPhoneNumber);
          if (!secondDoc) {
            console.log("de plano no existe el num");
            this.iCCService.removeIncomingCall(individualCall.id);
            this.modalCall = false;
            this.closeModalCall = false;
            return;
          }
          else {
            //La llamada fue identificada con un numero adicional y se asigna su información
            companyDoc = secondDoc
          }
        };
        //La llamada fue identificada y se asigna su información
        this.callerCompany = companyDoc;

        var customer = await this.contactService.getContact(callerPhoneNumber, this.callerCompany.uid);
        if (customer.length != 0) {
          //El contacto ha sido identificado y se muestra su información
          this.clientLoader = false;
          this.callerIdentified = true;
          this.currentCustomerCaller = customer[0];
          localStorage.removeItem("iCCId");
        }

        this.currrentIncomingCall.push(individualCall);
        this.modalCall = true;
        this.closeModalCall = true;
        if (localStorage.getItem("isCallOnFocus") != "true") {
          this.openPopup()
        }
        localStorage.setItem("isCallOnFocus", "true")
        this.callBackSubscription = interval(30000).subscribe((x) => {
          if (localStorage.getItem("isCallOnFocus") == "false") {
            this.callBackSubscription.unsubscribe();
            this.iCCService.removeIncomingCall(individualCall.id);
            this.modalCall = false;
            this.closeModalCall = false;
          } else {
            this.callBackSubscription.unsubscribe();
            this.iCCService.removeIncomingCall(individualCall.id);
            localStorage.setItem("isCallOnFocus", "false")
          }
        });
      })
    } catch (error) {
      console.log(error);
      this.clientLoader = false;
      this.callerIdentified = false;
      this.currentCustomerCaller = { telefono: '' };
      localStorage.removeItem("iCCId");
    }
  }

  async openPopup() {
    try {
      if (window.document.hasFocus() || window.document.hidden) {
        window.open("/incomming-call", "_blank", 'width=400,height=550')
      }
    } catch (error) {
      console.log(error);

    }
  }

  clearWeeklyNotification() {
    this.hasNewWeeklyReport = false;
  }
}
